import React from 'react';

export function ListaIcon({ className = 'cls-1', ...props }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 20.91 25.24'
			{...props}
		>
			<title>icono04</title>
			<g id='Layer_2' data-name='Layer 2'>
				<g id='Contenido-Home'>
					<path
						className={className}
						d='M19.1,25.24H1.8A1.81,1.81,0,0,1,0,23.43V1.8A1.81,1.81,0,0,1,1.8,0H19.1a1.81,1.81,0,0,1,1.81,1.8V23.43A1.81,1.81,0,0,1,19.1,25.24ZM1.8,1.31a.49.49,0,0,0-.49.49V23.43a.49.49,0,0,0,.49.49H19.1a.49.49,0,0,0,.49-.49V1.8a.49.49,0,0,0-.49-.49Z'
					></path>
					<path
						className={className}
						d='M5.6,8.24h0A.67.67,0,0,1,5.07,8L4.39,7a.65.65,0,0,1,.16-.91.65.65,0,0,1,.91.15l.18.24L6.78,5.12a.65.65,0,0,1,1,.83L6.11,8A.67.67,0,0,1,5.6,8.24Z'
					></path>
					<path
						className={className}
						d='M16,7.59H9.91a.66.66,0,1,1,0-1.31H16a.66.66,0,0,1,0,1.31Z'
					></path>
					<path
						className={className}
						d='M5.6,14.3h0A.65.65,0,0,1,5.07,14l-.68-.94a.66.66,0,0,1,1.07-.76l.18.24,1.14-1.38a.65.65,0,0,1,1,.83L6.11,14.06A.67.67,0,0,1,5.6,14.3Z'
					></path>
					<path
						className={className}
						d='M16,13.65H9.91a.66.66,0,1,1,0-1.31H16a.66.66,0,0,1,0,1.31Z'
					></path>
					<path
						className={className}
						d='M5.6,20.36h0a.65.65,0,0,1-.51-.28l-.68-.94a.66.66,0,0,1,.16-.92.65.65,0,0,1,.91.16l.18.24,1.14-1.38a.64.64,0,0,1,.92-.1.66.66,0,0,1,.09.93L6.11,20.12A.67.67,0,0,1,5.6,20.36Z'
					></path>
					<path
						className={className}
						d='M16,19.71H9.91a.66.66,0,1,1,0-1.31H16a.66.66,0,0,1,0,1.31Z'
					></path>
				</g>
			</g>
		</svg>
	);
}

export default ListaIcon;

